import { HearthBeatLoader } from '../../../loaders';
import React from 'react';

const LoadingIndicator: React.FunctionComponent<any> = () => {
  return <HearthBeatLoader loading variant="on-light" size="small" />;
};

export default LoadingIndicator;
